module.exports = __webpack_public_path__ + "static/media/m (8).17052d63.jpg";